import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Typography,
} from "../material-old";
import { Button, Button as AntButton, message, Table as AntTable } from "antd";
import { useEffect, useState } from "react";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { User } from "../../redux/interfaces/user.types.ts";
import { fetchAllUsers } from "../../redux/actions/usersActions.tsx";
import { CoreLoading } from "../common/CoreLoading.tsx";
import { USERS_TABLE_HEAD } from "./fixtures/usersTable.tsx";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

export const TableComponent = () => {
  const [page, setPage] = useState(1);
  const { text: search } = useAppSelector((state) => state.search);

  const limit = 5;
  const {
    results: users,
    next,
    previous,
    count,
    loading,
  } = useAppSelector((state) => state.user);
  const [dataSource, setDataSource] = useState<any[]>([]);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const totalPages = Math.ceil(count / limit);

  useEffect(() => {
    fetchInitialUsers();
  }, []);

  useEffect(() => {
    onFilterUsers();
  }, [search]);

  useEffect(() => {
    onUpdateSource();
  }, [users]);

  const onFilterUsers = () => {
    if (!search) {
      onUpdateDataSource(users);
      return;
    }

    const filtered = users.filter(
      (user) =>
        user.name.toLowerCase().includes(search.toLowerCase()) ||
        user.email.toLowerCase().includes(search.toLowerCase()),
    );
    onUpdateDataSource(filtered);
  };

  const onUpdateDataSource = (users: User[]) => {
    const data = users.map((user) => ({
      ...user,
      key: user.id,
      onClick: () => navigate(`/users/${user.id}`),
    }));
    setDataSource(data);
  };

  const onUpdateSource = () => {
    if (!users.length) return;
    onUpdateDataSource(users);
  };

  const fetchInitialUsers = async () => {
    if (loading) return;

    try {
      await dispatch(fetchAllUsers(`/accounts/users/?limit=${limit}`)).unwrap();
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudieron cargar los usuarios."));
    }
  };

  const onFetchPrevious = async () => {
    const users = await dispatch(fetchAllUsers(previous!)).unwrap();
    setPage(page - 1);

    onUpdateDataSource(users.results);
  };

  const onFetchNext = async () => {
    const users = await dispatch(fetchAllUsers(next!)).unwrap();
    setPage(page + 1);

    onUpdateDataSource(users.results);
  };

  const onCreateUser = () => navigate("/auth/register");

  if (loading) {
    return (
      <Card className="w-full p-8">
        <CoreLoading size={1} />
      </Card>
    );
  }

  return (
    <Card className="w-full p-8">
      {contextHolder}
      <CardHeader floated={false} shadow={false} className="rounded-none">
        <Typography variant="h5" color="blue-gray" className="mb-2">
          Usuarios
        </Typography>
        <div className="flex justify-end">
          <Button
            type="dashed"
            icon={<AppstoreAddOutlined />}
            onClick={onCreateUser}
          >
            Añadir usuario
          </Button>
        </div>
      </CardHeader>
      <CardBody className="overflow-scroll px-0">
        <AntTable
          columns={USERS_TABLE_HEAD}
          dataSource={dataSource}
          pagination={false}
        />
      </CardBody>
      <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
        <Typography variant="small" color="blue-gray" className="font-normal">
          Página {page} de {totalPages}
        </Typography>
        <div className="flex gap-2">
          {!!previous && (
            <AntButton
              type="dashed"
              className="flex items-center gap-3"
              onClick={onFetchPrevious}
            >
              Anterior
            </AntButton>
          )}
          {!!next && (
            <AntButton
              type="primary"
              className="flex items-center gap-3"
              onClick={onFetchNext}
            >
              Siguiente
            </AntButton>
          )}
        </div>
      </CardFooter>
    </Card>
  );
};
